<template>
  <Dialog :open="open" @update:open="emitClose">
    <DialogContent class="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Upgrade Plan</DialogTitle>
        <DialogDescription>
          You're upgrading your plan for <strong>{{ merchantName }}</strong>
        </DialogDescription>
      </DialogHeader>

      <div class="flex flex-col gap-4 py-4">
        <div class="col-span-1">
          <TextInput
            id="currentPlan"
            label="Current Plan"
            placeholder="Company registered name"
            test-id="current_plan"
            :disabled="true"
            v-model:input="currentPlan"
          />
        </div>

        <div class="space-y-2">
          <LabelComponent>Select New Plan</LabelComponent>
          <Select v-model="selectedPlan">
            <SelectTrigger>
              <SelectValue placeholder="Select plan" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup v-for="plan in plans" :key="plan.key" :value="plan.value">
                <SelectItem :value="plan.value">{{ plan.key }}</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>

      <DialogFooter>
        <div class="flex justify-end gap-4 mt-4 mr-8">
          <Button type="button" variant="outline" @click="emitClose">Cancel</Button>
          <Button class="w-auto" :disabled="!selectedPlan || selectedPlan === currentPlan" @click="onSubmit">
            Confirm Upgrade
          </Button>
        </div>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import TextInput from '@/components/common/TextInput.vue';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ref, watch } from 'vue';

const props = defineProps({
  merchantName: String,
  open: Boolean,
  merchantId: {
    type: String,
    required: true,
  },
  currentPlan: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:open', 'submit']);

const currentPlan = ref(props.currentPlan);
const plans = ref([
  {
    key: 'Standard',
    value: 'STANDARD',
  },
  {
    key: 'Pro',
    value: 'PRO',
  },
  {
    key: 'Custom',
    value: 'CUSTOM',
  },
]);

const selectedPlan = ref('');

watch(
  () => props.open,
  (val) => {
    if (val) selectedPlan.value = '';
  },
);

const emitClose = () => {
  emit('update:open', false);
};

const onSubmit = () => {
  emit('submit', {
    merchantId: props.merchantId,
    currentPlan: currentPlan,
    newPlan: selectedPlan.value,
  });
  emitClose();
};
</script>
